import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from 'primereact/card';
import { Rating } from 'primereact/rating';
import { useAuth } from '../../context/AuthContext';

const YoutubeViewer = ({ videoId }) => {
    const auth = useAuth();
    const userRole = auth.role || null;
    const [loading, setLoading] = useState(true);
    const [videoInfo, setVideoInfo] = useState(null);
    const [error, setError] = useState(null);
    const [canVote, setCanVote] = useState(false);
    const [userRating, setUserRating] = useState(null);
    const [averageRating, setAverageRating] = useState(null);

    const extractVideoId = (input) => {
        if (!input) return null;
        if (/^[a-zA-Z0-9_-]{11}$/.test(input)) return input;

        const shortMatch = input.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
        if (shortMatch) return shortMatch[1];

        const watchMatch = input.match(/v=([a-zA-Z0-9_-]{11})/);
        if (watchMatch) return watchMatch[1];

        const embedMatch = input.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
        if (embedMatch) return embedMatch[1];

        return null;
    };

    useEffect(() => {
        const fetchVideoInfo = async () => {
            try {
                const response = await axios.get(`https://us-central1-inprojuy-f1173.cloudfunctions.net/app/concursoresp/${videoId}`);
                const data = response.data;
                data.alumno_o_curso = data.alumno_o_curso?.toUpperCase();
                data.escuela = data.escuela?.toUpperCase();
                setVideoInfo(data);
            } catch (error) {
                console.error('Error fetching video info:', error);
                setError('Error fetching video info');
            } finally {
                setLoading(false);
            }
        };

        fetchVideoInfo();
    }, [videoId]);


    useEffect(() => {
        const fetchAverageRating = async () => {
            try {
                const response = await axios.get(`https://us-central1-inprojuy-f1173.cloudfunctions.net/app/average-rating/${videoId}`);
                setAverageRating(response.data.averageRating);
            } catch (error) {
                console.error('Error fetching average rating:', error);
                setError('Error fetching average rating');
            }
        };

        fetchAverageRating();
    }, [videoId]);

    useEffect(() => {
        const fetchUserRating = async () => {
            try {
                const response = await axios.get(`https://us-central1-inprojuy-f1173.cloudfunctions.net/app/votes/${auth.user}/${videoId}`);
                const userVote = response.data[0]?.rating;
                setUserRating(userVote);
            } catch (error) {
                console.error('Error fetching user rating:', error);
                setError('Error fetching user rating');
            }
        };

        if (auth.user && ['admin', 'adminauto', 'jurado'].includes(userRole)) {
            fetchUserRating();
        }
    }, [auth.user, userRole, videoId]);

    useEffect(() => {
        setCanVote(['admin', 'adminauto', 'jurado'].includes(userRole));
    }, [userRole]);

    const handleRatingChange = (event) => {
        const ratingValue = event.value;
        setUserRating(ratingValue);

        axios.post(`https://us-central1-inprojuy-f1173.cloudfunctions.net/app/vote`, {
            idVideo: videoId,
            usuario: auth.user,
            rating: ratingValue
        })
        .then(response => {
            console.log('Vote submitted successfully:', response.data);
        })
        .catch(error => {
            console.error('Error submitting vote:', error);
            setError('Error submitting vote');
        });
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="p-d-flex p-jc-center">
            <Card className="p-mt-2" style={{ width: '70%' }}>
                {videoInfo ? (
                    <>
                        <h2>Video de {videoInfo.alumno_o_curso}</h2>
                        <div style={{ marginBottom: '10px' }}>
                            <span>Escuela: {videoInfo.escuela}</span>
                        </div>
                        <div className="p-d-flex p-jc-center p-mt-2">
                            {averageRating !== null ? (
                                <div>
                                    <span>Promedio de votaciones: </span>
                                    <Rating value={averageRating} readonly cancel={false} />
                                </div>
                            ) : (
                                <div>No hay votos aún</div>
                            )}
                        </div>
                        <div className="p-d-flex p-jc-center">
                            <iframe
                                width="560"
                                height="315"
                                src={`https://www.youtube.com/embed/${extractVideoId(videoInfo.link)}`}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        {canVote && (
                            <div className="p-d-flex p-jc-center p-mt-2">
                                <span>Mi votación: </span>
                                <Rating value={userRating} onChange={handleRatingChange} cancel={true} />
                            </div>
                        )}
                    </>
                ) : (
                    <p>{error || 'Error fetching video info'}</p>
                )}
            </Card>
        </div>
    );
};

export default YoutubeViewer;
